import _objectWithoutProperties from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
var _excluded = ["items", "rounds"],
    _excluded2 = ["items"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { Util_exports } from "./chunk-72S2U22Q.mjs";
import { socialGroup_exports } from "./chunk-7S5ICI7P.mjs";
import { survey_exports } from "./chunk-5K3PDMR6.mjs";
import { target_exports } from "./chunk-FS3MT3BD.mjs";
import { upload_exports } from "./chunk-MXF3G2DP.mjs";
import { user_exports } from "./chunk-JG5WQ4BR.mjs";
import { weimob_exports } from "./chunk-24DV5Z2S.mjs";
import { measurement_exports } from "./chunk-IHK6CWWJ.mjs";
import { notification_exports } from "./chunk-LLHH6M6L.mjs";
import { post_exports } from "./chunk-SFDLIL34.mjs";
import { profile_exports } from "./chunk-7TPJ6PQD.mjs";
import { searchLocation_exports } from "./chunk-JMNL7RSN.mjs";
import { session_exports } from "./chunk-CGTO4TGV.mjs";
import { essays_exports } from "./chunk-SKXG6G3T.mjs";
import { explore_exports } from "./chunk-A3PPVWL3.mjs";
import { factory_exports } from "./chunk-UBE7H7II.mjs";
import { food_exports } from "./chunk-GIH73ZCA.mjs";
import { group_exports } from "./chunk-YQUWXCWM.mjs";
import { invoice_exports } from "./chunk-PKTGEUL6.mjs";
import { activity_exports } from "./chunk-25KMQCR4.mjs";
import { article_exports } from "./chunk-7MOYD7BQ.mjs";
import { bind_exports } from "./chunk-ROG3FJTY.mjs";
import { chatbot_exports } from "./chunk-YTB2RS23.mjs";
import { client_exports } from "./chunk-IAZIMRQG.mjs";
import { company_exports } from "./chunk-NRYMC4PS.mjs";
import { diary_exports } from "./chunk-SMSERGVQ.mjs";
import { fetcher_default } from "./chunk-GONJSORR.mjs";
import { config } from "./chunk-5XJQLH56.mjs";
import { __export } from "./chunk-QK4PKNB3.mjs"; // src/services/chat.ts

var chat_exports = {};

__export(chat_exports, {
  addChats: function addChats() {
    return _addChats;
  },
  addChatsAnnouncements: function addChatsAnnouncements() {
    return _addChatsAnnouncements;
  },
  addChatsMembers: function addChatsMembers() {
    return _addChatsMembers;
  },
  apiIssueReturn: function apiIssueReturn() {
    return _apiIssueReturn;
  },
  apiPublicIssueReturn: function apiPublicIssueReturn() {
    return _apiPublicIssueReturn;
  },
  createAttachment: function createAttachment() {
    return _createAttachment;
  },
  deleteChatsAnnouncement: function deleteChatsAnnouncement() {
    return _deleteChatsAnnouncement;
  },
  enterChats: function enterChats() {
    return _enterChats;
  },
  formatECOutgoingMessage: function formatECOutgoingMessage() {
    return _formatECOutgoingMessage;
  },
  formatIncomingMessages: function formatIncomingMessages() {
    return _formatIncomingMessages;
  },
  formatInsertedMessage: function formatInsertedMessage() {
    return _formatInsertedMessage;
  },
  formatOutgoingMessage: function formatOutgoingMessage() {
    return _formatOutgoingMessage;
  },
  getChats: function getChats() {
    return _getChats;
  },
  getChatsAnnouncements: function getChatsAnnouncements() {
    return _getChatsAnnouncements;
  },
  getLastReadAtIndex: function getLastReadAtIndex() {
    return _getLastReadAtIndex;
  },
  getMediaUploadInfo: function getMediaUploadInfo() {
    return getMediaUploadInfo3;
  },
  getMessageUserFromUser: function getMessageUserFromUser() {
    return _getMessageUserFromUser;
  },
  handleMappingInlineMedia: function handleMappingInlineMedia() {
    return _handleMappingInlineMedia;
  },
  leaveChats: function leaveChats() {
    return _leaveChats;
  },
  muteChats: function muteChats() {
    return _muteChats;
  },
  pinChats: function pinChats() {
    return _pinChats;
  },
  searchChatsMessage: function searchChatsMessage() {
    return _searchChatsMessage;
  },
  sortMessagesByTime: function sortMessagesByTime() {
    return _sortMessagesByTime;
  },
  unMuteChats: function unMuteChats() {
    return _unMuteChats;
  },
  unPinChats: function unPinChats() {
    return _unPinChats;
  },
  uploadMediaFile: function uploadMediaFile() {
    return _uploadMediaFile;
  }
});

import _2 from "lodash";
import * as uuid from "uuid"; // src/services/index.ts

var services_exports = {};

__export(services_exports, {
  activity: function activity() {
    return activity_exports;
  },
  article: function article() {
    return article_exports;
  },
  bind: function bind() {
    return bind_exports;
  },
  chat: function chat() {
    return chat_exports;
  },
  chatbot: function chatbot() {
    return chatbot_exports;
  },
  client: function client() {
    return client_exports;
  },
  company: function company() {
    return company_exports;
  },
  diary: function diary() {
    return diary_exports;
  },
  essays: function essays() {
    return essays_exports;
  },
  explore: function explore() {
    return explore_exports;
  },
  factory: function factory() {
    return factory_exports;
  },
  fileUpload: function fileUpload() {
    return fileUpload_exports;
  },
  food: function food() {
    return food_exports;
  },
  group: function group() {
    return group_exports;
  },
  invoice: function invoice() {
    return invoice_exports;
  },
  measurement: function measurement() {
    return measurement_exports;
  },
  member: function member() {
    return member_exports;
  },
  note: function note() {
    return note_exports;
  },
  notification: function notification() {
    return notification_exports;
  },
  post: function post() {
    return post_exports;
  },
  profile: function profile() {
    return profile_exports;
  },
  searchLocation: function searchLocation() {
    return searchLocation_exports;
  },
  session: function session() {
    return session_exports;
  },
  socialGroup: function socialGroup() {
    return socialGroup_exports;
  },
  survey: function survey() {
    return survey_exports;
  },
  target: function target() {
    return target_exports;
  },
  upload: function upload() {
    return upload_exports;
  },
  user: function user() {
    return user_exports;
  },
  weimob: function weimob() {
    return weimob_exports;
  }
}); // src/services/fileUpload.ts


var fileUpload_exports = {};

__export(fileUpload_exports, {
  createFileUploadData: function createFileUploadData() {
    return _createFileUploadData;
  },
  getFileUploadList: function getFileUploadList() {
    return _getFileUploadList;
  },
  getMediaUploadInfo: function getMediaUploadInfo() {
    return _getMediaUploadInfo;
  },
  uploadMediaDirect: function uploadMediaDirect() {
    return _uploadMediaDirect;
  }
});

var _getMediaUploadInfo = function _getMediaUploadInfo(_ref) {
  var extname = _ref.extname;
  return fetcher_default.get("/v4/upload_files/media_upload_info", {
    extname: extname
  });
};

var _uploadMediaDirect = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(media) {
    var _uid;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _uid = media._uid;
            _context.next = 3;
            return upload_exports.uploadMediaDirect(media);

          case 3:
            return _context.abrupt("return", _uid);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function _uploadMediaDirect(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var _createFileUploadData = function _createFileUploadData(param) {
  return fetcher_default.post("/v4/upload_files", param);
};

var _getFileUploadList = function _getFileUploadList(_ref3) {
  var data_type = _ref3.data_type,
      client_id = _ref3.client_id;
  return fetcher_default.get("/v4/upload_files", {
    data_type: data_type,
    client_id: client_id
  });
}; // src/services/member.ts


var member_exports = {};

__export(member_exports, {
  getAvatarUploadInfo: function getAvatarUploadInfo() {
    return _getAvatarUploadInfo;
  },
  uploadMediaDirect: function uploadMediaDirect() {
    return uploadMediaDirect2;
  }
});

var _getAvatarUploadInfo = function _getAvatarUploadInfo() {
  return fetcher_default.get("/v4/members/avatar_upload_info");
};

var uploadMediaDirect2 = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(media) {
    var _uid;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _uid = media._uid;
            _context2.next = 3;
            return upload_exports.uploadMediaDirect(media);

          case 3:
            return _context2.abrupt("return", _uid);

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function uploadMediaDirect2(_x2) {
    return _ref4.apply(this, arguments);
  };
}(); // src/services/note.ts


var note_exports = {};

__export(note_exports, {
  createOrUpdateNote: function createOrUpdateNote() {
    return _createOrUpdateNote;
  },
  deleteComment: function deleteComment() {
    return _deleteComment;
  },
  deleteNote: function deleteNote() {
    return _deleteNote;
  },
  getAssetUid: function getAssetUid() {
    return _getAssetUid;
  },
  getClientHistoryAssets: function getClientHistoryAssets() {
    return _getClientHistoryAssets;
  },
  getClientNotes: function getClientNotes() {
    return _getClientNotes;
  },
  getDailyNutritionParam: function getDailyNutritionParam() {
    return _getDailyNutritionParam;
  },
  getHistoryAssets: function getHistoryAssets() {
    return _getHistoryAssets;
  },
  getMediaUploadInfo: function getMediaUploadInfo() {
    return getMediaUploadInfo2;
  },
  getNoteTags: function getNoteTags() {
    return _getNoteTags;
  },
  getPickerItemProps: function getPickerItemProps() {
    return _getPickerItemProps;
  },
  updateAssets: function updateAssets() {
    return _updateAssets;
  },
  updateComment: function updateComment() {
    return _updateComment;
  },
  updateFoodNote: function updateFoodNote() {
    return _updateFoodNote;
  },
  uploadMedia: function uploadMedia() {
    return _uploadMedia;
  },
  uploadMediaDirect: function uploadMediaDirect() {
    return uploadMediaDirect3;
  }
});

import _ from "lodash";
import moment from "moment";
import * as R from "ramda";

var today = function today() {
  return moment().format("YYYY-MM-DD");
};

var mapAssetAttribute = function mapAssetAttribute(asset) {
  var assetToCreate = R.omit(["uploadInfo", "filePath", "_id", "note_id", "items", "parent", "comments"], asset);
  return _objectSpread(_objectSpread({}, assetToCreate), {}, {
    items_attributes: R.map(R.omit(["item_details"]), asset.items || []),
    comments_attributes: R.reject(function (comment) {
      return !!(comment !== null && comment !== void 0 && comment.id);
    }, asset.comments || [])
  });
};

var getCommentAttributes = R.pipe(R.pathOr([], ["comments"]), R.reject(function (comment) {
  return R.isNotNil(comment === null || comment === void 0 ? void 0 : comment.id);
}), R.map(R.pick(["content", "sender_id", "sender_type"])));

var _deleteNote = function _deleteNote(id) {
  return fetcher_default["delete"]("/v4/notes/".concat(id));
};

var _getHistoryAssets = function _getHistoryAssets(_ref5) {
  var before = _ref5.before;
  return fetcher_default.get("/v4/assets/history", {
    before: before
  });
};

var _getClientHistoryAssets = function _getClientHistoryAssets(_ref6) {
  var before = _ref6.before,
      client_id = _ref6.client_id;
  return fetcher_default.get("/v4.1/assets/history", {
    before: before,
    client_id: client_id
  });
};

var _updateAssets = function _updateAssets(_ref7) {
  var noteID = _ref7.noteID,
      assets = _ref7.assets,
      _ref7$send_notificati = _ref7.send_notification,
      send_notification = _ref7$send_notificati === void 0 ? true : _ref7$send_notificati;

  var assets_attributes = _.map(assets, mapAssetAttribute);

  var payload = {
    assets_attributes: assets_attributes,
    send_notification: send_notification
  };
  return fetcher_default.put("/v4/notes/".concat(noteID), payload);
};

var _updateFoodNote = function _updateFoodNote(note) {
  var assets_attributes = _.map(note.assets || [], mapAssetAttribute);

  var comments_attributes = getCommentAttributes(note);

  var payload = _objectSpread(_objectSpread({}, R.omit(["assets", "comments"], note)), {}, {
    assets_attributes: assets_attributes,
    comments_attributes: comments_attributes
  });

  return fetcher_default.put("/v4/notes/".concat(note.id), payload);
};

var _createOrUpdateNote = function _createOrUpdateNote(_ref8) {
  var type = _ref8.type,
      note = _ref8.note,
      assets = _ref8.assets,
      oldAssets = _ref8.oldAssets,
      items = _ref8.items,
      date = _ref8.date,
      meal_order = _ref8.meal_order,
      id = _ref8.id,
      noteComments = _ref8.comments,
      clientId = _ref8.clientId,
      sessions = _ref8.sessions;

  var newAssets = _.concat(_.map(oldAssets, function (asset) {
    return _.find(assets, {
      id: asset.id
    }) || asset;
  }), _.filter(assets, function (_ref9) {
    var id2 = _ref9.id;
    return !id2;
  }));

  var _is_post = note.isPost,
      selectTags = note.selectTags,
      _group_class_ids = note.groupIds,
      _social_group_ids = note.socialGroupIds,
      place_attributes = note.place,
      _tag_members = note.tagMembers,
      water_intake = note.waterIntake,
      sleep_at = note.sleep_at,
      fall_asleep_dur = note.fall_asleep_dur,
      wakeup_at = note.wakeup_at,
      getup_at = note.getup_at,
      sleepInteruptCount = note.sleepInteruptCount,
      interuptReason = note.interuptReason,
      interuptReason_other = note.interuptReason_other,
      sleepQuality = note.sleepQuality,
      wakeQuality = note.wakeQuality,
      snapDuration = note.snapDuration,
      daytimeSpirit = note.daytimeSpirit,
      main_choice_id = note.main_choice_id,
      main_dislike_choice_id = note.main_dislike_choice_id,
      others_choice_id = note.others_choice_id,
      representive_id = note.representive_id,
      emotion = note.emotion,
      level = note.level,
      time = note.time,
      place = note.place,
      detail = note.detail,
      reason = note.reason,
      action = note.action,
      main = note.main,
      stomach = note.stomach,
      muscle = note.muscle,
      other = note.other,
      healthy = note.healthy,
      breakfast = note.breakfast,
      lunch = note.lunch,
      teatime = note.teatime,
      dinner = note.dinner,
      pee_frequency = note.pee_frequency,
      pee_color = note.pee_color,
      pee_smell = note.pee_smell,
      pee_bubble = note.pee_bubble,
      stool_frequency = note.stool_frequency,
      diarrhea = note.diarrhea,
      stool_shape = note.stool_shape,
      stool_smell = note.stool_smell,
      stool_float = note.stool_float,
      stool_color = note.stool_color,
      stool_speed = note.stool_speed,
      stool_other = note.stool_other,
      _post_content = note.post_content;

  var move_sessions_attributes = _.map(sessions, function (session) {
    var session_items = session.items,
        rounds = session.rounds,
        sessionToCreate = _objectWithoutProperties(session, _excluded);

    return _objectSpread(_objectSpread({}, sessionToCreate), {}, {
      items_attributes: session_items,
      rounds_attributes: _.map(rounds, function (round) {
        var round_items = round.items,
            roundToCreate = _objectWithoutProperties(round, _excluded2);

        return _objectSpread(_objectSpread({}, roundToCreate), {}, {
          items_attributes: _.map(round_items, function (item) {
            return _.omit(item, "item");
          })
        });
      })
    });
  });

  var assets_attributes = _.map(newAssets, mapAssetAttribute);

  var isWater = type === "WaterNote" || type === "water";
  var isSleep = type === "SleepNote" || type === "sleep";
  var isFlowery = type === "FloweryNote" || type === "flowery";
  var isMood = type === "MoodNote" || type === "mood";
  var isDiet = type === "DietNote" || type === "diet";
  var isStool = type === "StoolNote" || type === "stool";

  if (isWater) {
    if (items.length === 0) {
      items.push({
        water_intake: water_intake
      });
    } else {
      items[0].water_intake = water_intake;
    }
  }

  var sleep_data = _.merge(note.sleep_data, {
    sleep_at: sleep_at,
    fall_asleep_dur: fall_asleep_dur,
    wakeup_at: wakeup_at,
    getup_at: getup_at,
    sleepInteruptCount: sleepInteruptCount,
    interuptReason: interuptReason,
    interuptReason_other: interuptReason_other,
    sleepQuality: sleepQuality,
    wakeQuality: wakeQuality,
    snapDuration: snapDuration,
    daytimeSpirit: daytimeSpirit
  });

  var flowery_data = _.merge(note.flowery_data, {
    main_choice_id: JSON.stringify(main_choice_id),
    main_dislike_choice_id: JSON.stringify(main_dislike_choice_id),
    others_choice_id: JSON.stringify(others_choice_id),
    representive_id: JSON.stringify(representive_id)
  });

  var mood_data = _.merge(note.mood_data, {
    emotion: emotion,
    level: level,
    time: time,
    place: place,
    detail: detail,
    reason: reason,
    action: action
  });

  console.log(breakfast);

  var diet_data = _.merge(note.diet_data, {
    main: JSON.stringify(main),
    stomach: JSON.stringify(stomach),
    muscle: JSON.stringify(muscle),
    other: other,
    healthy: healthy,
    breakfast: JSON.stringify(breakfast),
    lunch: JSON.stringify(lunch),
    teatime: JSON.stringify(teatime),
    dinner: JSON.stringify(dinner)
  });

  var stool_data = _.merge(note.stool_data, {
    pee_frequency: pee_frequency,
    pee_color: pee_color,
    pee_smell: pee_smell,
    pee_bubble: pee_bubble,
    stool_frequency: stool_frequency,
    diarrhea: diarrhea,
    stool_shape: stool_shape,
    stool_smell: stool_smell,
    stool_float: stool_float,
    stool_color: stool_color,
    stool_speed: stool_speed,
    stool_other: JSON.stringify(stool_other)
  });

  var payload = _objectSpread(_objectSpread({
    client_id: clientId,
    _is_post: _is_post,
    _group_class_ids: _group_class_ids,
    _social_group_ids: _social_group_ids,
    tag_ids: _.map(selectTags, function (_ref10) {
      var id2 = _ref10.id;
      return id2;
    }),
    meal_order: meal_order,
    date: date,
    items_attributes: items,
    comments_attributes: _.reject(noteComments, "id"),
    move_sessions_attributes: move_sessions_attributes,
    assets_attributes: assets_attributes,
    place_attributes: place_attributes,
    _tag_members: _tag_members
  }, note), {}, {
    sleep_data: sleep_data,
    flowery_data: flowery_data,
    mood_data: mood_data,
    diet_data: diet_data,
    stool_data: stool_data,
    _post_content: _post_content
  });

  if (!isFlowery) {
    payload.flowery_data = void 0;
  }

  if (!isSleep) {
    payload.sleep_data = void 0;
  }

  if (!isMood) {
    payload.mood_data = void 0;
  }

  if (!isDiet) {
    payload.diet_data = void 0;
  }

  if (!isStool) {
    payload.stool_data = void 0;
  }

  if (id) {
    return fetcher_default.put("/v4/notes/".concat(id), payload);
  }

  return fetcher_default.post("/v4/".concat(type, "_notes"), payload);
};

var getMediaUploadInfo2 = function getMediaUploadInfo2(_ref11) {
  var extname = _ref11.extname;
  return fetcher_default.get("/v4/notes/media_upload_info", {
    extname: extname,
    date: today()
  });
};

var _uploadMedia = /*#__PURE__*/function () {
  var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(media) {
    var _uid;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _uid = media._uid;
            _context3.next = 3;
            return upload_exports.uploadMedia("/v4/assets/upload", media);

          case 3:
            return _context3.abrupt("return", _uid);

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function _uploadMedia(_x3) {
    return _ref12.apply(this, arguments);
  };
}();

var uploadMediaDirect3 = /*#__PURE__*/function () {
  var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(media) {
    var _uid;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _uid = media._uid;
            _context4.next = 3;
            return upload_exports.uploadMediaDirect(media);

          case 3:
            return _context4.abrupt("return", _uid);

          case 4:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function uploadMediaDirect3(_x4) {
    return _ref13.apply(this, arguments);
  };
}();

var _getDailyNutritionParam = function _getDailyNutritionParam(foodItemsData) {
  return _.chain(foodItemsData).toPairs().invokeMap("join", "=").join("&").value();
};

var _getAssetUid = function _getAssetUid(asset) {
  return "".concat(asset.id || "000").concat(asset.url || asset.uri);
};

var _getPickerItemProps = function _getPickerItemProps(_ref14) {
  var item = _ref14.item,
      orderOffset = _ref14.orderOffset,
      selectedItems = _ref14.selectedItems;
  var order = _.findIndex(selectedItems, {
    _uid: _getAssetUid(item)
  }) + 1;
  var selected = order > 0 && order > orderOffset;
  var selectedOrder = selected ? order - orderOffset : order;

  var matched = _.find(selectedItems, {
    _uid: _getAssetUid(item)
  });

  var disabled = matched ? matched.disabled : false;
  return {
    disabled: disabled,
    selectedOrder: selectedOrder
  };
};

var _getNoteTags = function _getNoteTags() {
  return fetcher_default.get("/v4/tags");
};

var _updateComment = function _updateComment(_ref15) {
  var id = _ref15.id,
      content = _ref15.content;
  return fetcher_default.put("/v4/comments/".concat(id), {
    content: content
  });
};

var _deleteComment = function _deleteComment(_ref16) {
  var id = _ref16.id;
  return fetcher_default["delete"]("/v4/comments/".concat(id));
};

var _getClientNotes = function _getClientNotes(_ref17) {
  var type = _ref17.type,
      client_id = _ref17.client_id;
  return fetcher_default.get("/v4/notes/client_notes", {
    type: type,
    client_id: client_id
  });
}; // src/services/chat.ts


var app_name = config.appName;

var _handleMappingInlineMedia = function _handleMappingInlineMedia(message) {
  if (!message.text || !message.text.startsWith("https://")) {
    return message;
  }

  var mimeType = Util_exports.getMimeTypeFromURL(message.text);

  if (message.text.startsWith("https://") && mimeType !== null && mimeType !== void 0 && mimeType.startsWith("image")) {
    return _objectSpread(_objectSpread({}, message), {}, {
      mediaUrl: message.text,
      text: "",
      mediaType: "image"
    });
  } else if (message.text.startsWith("https://") && message.text.endsWith(".m3u8")) {
    return _objectSpread(_objectSpread({}, message), {}, {
      mediaUrl: message.text,
      text: "",
      mediaType: "video"
    });
  }

  return message;
};

var _formatIncomingMessages = function _formatIncomingMessages(messages) {
  return _2.map(messages, function (msg) {
    return _objectSpread(_objectSpread({}, msg), {}, {
      createdAt: new Date(msg.time),
      user: {
        _id: msg.sender
      }
    });
  });
};

var _sortMessagesByTime = function _sortMessagesByTime(messages) {
  return _2.chain(messages).orderBy(["time"], ["desc"]).uniqBy("_id").value();
};

var _formatECOutgoingMessage = function _formatECOutgoingMessage(_ref18) {
  var message = _ref18.message,
      shopChatData = _ref18.shopChatData;
  var createdAt = message.createdAt,
      text = message.text,
      _id = message.user._id,
      mediaUrl = message.mediaUrl,
      mediaType = message.mediaType,
      displayText = message.displayText,
      tagMembers = message.tagMembers;
  var user_id = shopChatData.user_id,
      service_id = shopChatData.service_id;
  var newMessage = {
    type: "user",
    content: text,
    user_id: user_id,
    service_id: service_id
  };
  return newMessage;
};

var _formatOutgoingMessage = function _formatOutgoingMessage(_ref19) {
  var id = _ref19.id,
      message = _ref19.message;
  var createdAt = message.createdAt,
      _id = message.user._id;

  var msg = _handleMappingInlineMedia(message);

  var newMessage = _objectSpread(_objectSpread({}, msg), {}, {
    chatRoomId: id,
    sender: _id,
    time: createdAt.toISOString()
  });

  return newMessage;
};

var _formatInsertedMessage = function _formatInsertedMessage(_ref20) {
  var message = _ref20.message;
  var createdAt = message.createdAt,
      _id = message._id,
      user = message.user;

  var newMessage = _objectSpread(_objectSpread({}, message), {}, {
    createdAt: createdAt || /* @__PURE__ */new Date(),
    _id: _id || uuid.v4(),
    user: user || {}
  });

  return newMessage;
};

var _getLastReadAtIndex = function _getLastReadAtIndex(_ref21) {
  var messages = _ref21.messages,
      readAt = _ref21.readAt;
  return messages.length - _2.sortedLastIndex(_2.map(messages, "time"), readAt);
};

var _getMessageUserFromUser = function _getMessageUserFromUser(user) {
  var _user$gid;

  return {
    _id: (_user$gid = user === null || user === void 0 ? void 0 : user.gid) !== null && _user$gid !== void 0 ? _user$gid : ""
  };
};

var getMediaUploadInfo3 = function getMediaUploadInfo3(_ref22) {
  var chatroom_id = _ref22.chatroom_id,
      extname = _ref22.extname,
      isService = _ref22.isService;
  var apiUrl = isService ? "/v4/service_chats/media_upload_info" : "/v4/chats/media_upload_info";
  return fetcher_default.get(apiUrl, {
    chatroom_id: chatroom_id,
    extname: extname
  });
};

var _uploadMediaFile = /*#__PURE__*/function () {
  var _ref24 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref23) {
    var mediaFile, chatroomID, isService, platform, previewID, uploadInfo, blob;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            mediaFile = _ref23.mediaFile, chatroomID = _ref23.chatroomID, isService = _ref23.isService, platform = _ref23.platform, previewID = _ref23.previewID;
            _context5.next = 3;
            return getMediaUploadInfo3({
              chatroom_id: chatroomID,
              extname: mediaFile.name,
              isService: isService
            });

          case 3:
            uploadInfo = _context5.sent;
            _context5.next = 6;
            return upload_exports.fileToBlob(mediaFile);

          case 6:
            blob = _context5.sent;
            _context5.prev = 7;
            _context5.next = 10;
            return upload_exports.uploadMediaDirect({
              blob: blob,
              platform: platform,
              uploadInfo: _objectSpread(_objectSpread({}, uploadInfo), {}, {
                resultUrl: uploadInfo.result_url,
                formData: uploadInfo.form_data
              })
            });

          case 10:
            _context5.next = 15;
            break;

          case 12:
            _context5.prev = 12;
            _context5.t0 = _context5["catch"](7);
            throw {
              error: _context5.t0,
              _id: previewID
            };

          case 15:
            return _context5.abrupt("return", uploadInfo.result_url);

          case 16:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[7, 12]]);
  }));

  return function _uploadMediaFile(_x5) {
    return _ref24.apply(this, arguments);
  };
}();

var _createAttachment = function _createAttachment(_ref25) {
  var chatroom_id = _ref25.chatroom_id,
      url = _ref25.url,
      message_id = _ref25.message_id,
      date = _ref25.date,
      isService = _ref25.isService;
  var apiUrl = isService ? "/v4/service_chats/create_attachment" : "/v4/chats/create_attachment";
  return fetcher_default.post(apiUrl, {
    chatroom_id: chatroom_id,
    url: url,
    message_id: message_id,
    date: date
  });
};

var _getChats = function _getChats(payload) {
  return fetcher_default.get("/v4/chats", payload);
};

var _addChats = function _addChats(payload) {
  return fetcher_default.post("/v4/chats", payload);
};

var _addChatsMembers = function _addChatsMembers(payload) {
  return fetcher_default.post("/v4/chats/add_members", payload);
};

var _leaveChats = function _leaveChats(payload) {
  return fetcher_default.post("/v4/chats/leave", payload);
};

var _enterChats = function _enterChats(payload) {
  return fetcher_default.post("/v4/chats/enter", payload);
};

var _muteChats = function _muteChats(payload) {
  return fetcher_default.post("/v4/chats/mute", payload);
};

var _unMuteChats = function _unMuteChats(payload) {
  return fetcher_default.post("/v4/chats/unmute", payload);
};

var _pinChats = function _pinChats(payload) {
  return fetcher_default.post("/v4/chats/pin", payload);
};

var _unPinChats = function _unPinChats(payload) {
  return fetcher_default.post("/v4/chats/unpin", payload);
};

var _apiPublicIssueReturn = function _apiPublicIssueReturn(payload) {
  return fetcher_default.post("/v4/public_feedbacks", _objectSpread(_objectSpread({}, payload), {}, {
    app_name: app_name
  }));
};

var _apiIssueReturn = function _apiIssueReturn(payload) {
  return fetcher_default.post("/v4/feedbacks", payload);
};

var _addChatsAnnouncements = function _addChatsAnnouncements(payload) {
  return fetcher_default.post("/v4/chat_announcements", payload);
};

var _getChatsAnnouncements = function _getChatsAnnouncements(payload) {
  return fetcher_default.get("/v4/chat_announcements", payload);
};

var _deleteChatsAnnouncement = function _deleteChatsAnnouncement(_ref26) {
  var noticeId = _ref26.noticeId;
  return fetcher_default["delete"]("/v4/chat_announcements/".concat(noticeId));
};

var _searchChatsMessage = function _searchChatsMessage(payload, options) {
  return fetcher_default.get("/v4/chats/search", payload, options);
};

export { _handleMappingInlineMedia as handleMappingInlineMedia, _formatIncomingMessages as formatIncomingMessages, _sortMessagesByTime as sortMessagesByTime, _formatECOutgoingMessage as formatECOutgoingMessage, _formatOutgoingMessage as formatOutgoingMessage, _formatInsertedMessage as formatInsertedMessage, _getLastReadAtIndex as getLastReadAtIndex, _getMessageUserFromUser as getMessageUserFromUser, getMediaUploadInfo3 as getMediaUploadInfo, _uploadMediaFile as uploadMediaFile, _createAttachment as createAttachment, _getChats as getChats, _addChats as addChats, _addChatsMembers as addChatsMembers, _leaveChats as leaveChats, _enterChats as enterChats, _muteChats as muteChats, _unMuteChats as unMuteChats, _pinChats as pinChats, _unPinChats as unPinChats, _apiPublicIssueReturn as apiPublicIssueReturn, _apiIssueReturn as apiIssueReturn, _addChatsAnnouncements as addChatsAnnouncements, _getChatsAnnouncements as getChatsAnnouncements, _deleteChatsAnnouncement as deleteChatsAnnouncement, _searchChatsMessage as searchChatsMessage, chat_exports, _getMediaUploadInfo as getMediaUploadInfo2, _uploadMediaDirect as uploadMediaDirect, _createFileUploadData as createFileUploadData, _getFileUploadList as getFileUploadList, fileUpload_exports, _getAvatarUploadInfo as getAvatarUploadInfo, uploadMediaDirect2, member_exports, _deleteNote as deleteNote, _getHistoryAssets as getHistoryAssets, _getClientHistoryAssets as getClientHistoryAssets, _updateAssets as updateAssets, _updateFoodNote as updateFoodNote, _createOrUpdateNote as createOrUpdateNote, getMediaUploadInfo2 as getMediaUploadInfo3, _uploadMedia as uploadMedia, uploadMediaDirect3, _getDailyNutritionParam as getDailyNutritionParam, _getAssetUid as getAssetUid, _getPickerItemProps as getPickerItemProps, _getNoteTags as getNoteTags, _updateComment as updateComment, _deleteComment as deleteComment, _getClientNotes as getClientNotes, note_exports, services_exports };